import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { ProfileBadgeConfiguration } from '../../../../models/users/dto/profile-badge-configuration';
import { ColorUtils } from '../../../../utils/color-utils';

@Component({
  selector: 'app-user-profile-badge',
  standalone: true,
  imports: [NgIf],
  templateUrl: './user-profile-badge.component.html',
  styleUrls: ['./user-profile-badge.component.scss']
})
export class UserProfileBadgeComponent implements OnChanges {
  @Input() public initials!: string;
  @Input() public profileBadgeConfiguration!: ProfileBadgeConfiguration;

  public textColor!: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.profileBadgeConfiguration && !!this.profileBadgeConfiguration) {
      this.textColor = ColorUtils.isDarkColor(this.profileBadgeConfiguration.backgroundColour) ? '#FFFFFF' : '#000000';
    }
  }
}
